__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@aviv-unified-frontend/branded-shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@aviv-csnt/react", "3.1.0", () => (() => (__webpack_require__(5794))), 1);
			register("@aviv-dxp/react-thor", "2.25.9", () => (() => (__webpack_require__(7279))), 1);
			register("@aviv-trak/feature-flagging", "1.4.2", () => (() => (__webpack_require__(2390))), 1);
			register("@aviv-unified-frontend/runtime/authentication", "11.0.3", () => (() => (__webpack_require__(8698))), 1);
			register("@aviv-unified-frontend/runtime/brand", "11.0.3", () => (() => (__webpack_require__(339))), 1);
			register("@aviv-unified-frontend/runtime/environment", "11.0.3", () => (() => (__webpack_require__(7403))), 1);
			register("@aviv-unified-frontend/runtime/fetcher", "11.0.3", () => (() => (__webpack_require__(1965))), 1);
			register("@aviv-unified-frontend/runtime/head", "11.0.3", () => (() => (__webpack_require__(8428))), 1);
			register("@aviv-unified-frontend/runtime/i18n", "11.0.3", () => (() => (__webpack_require__(2542))), 1);
			register("@aviv-unified-frontend/runtime/lifecycle", "11.0.3", () => (() => (__webpack_require__(400))), 1);
			register("@aviv-unified-frontend/runtime/monitoring", "11.0.3", () => (() => (__webpack_require__(9568))), 1);
			register("@aviv-unified-frontend/runtime/router", "11.0.3", () => (() => (__webpack_require__(2965))), 1);
			register("@aviv-web-core/tracking", "1.3.0", () => (() => (__webpack_require__(1689))), 1);
			register("@gemini/core", "3.6.0", () => (() => (__webpack_require__(1976))), 1);
			register("@react-aria/focus", "3.22.0", () => (() => (__webpack_require__(9501))), 1);
			register("@react-aria/i18n", "3.13.0", () => (() => (__webpack_require__(8764))), 1);
			register("@react-aria/interactions", "3.28.0", () => (() => (__webpack_require__(9150))), 1);
			register("@react-aria/overlays", "3.32.0", () => (() => (__webpack_require__(9700))), 1);
			register("@react-aria/ssr", "3.10.0", () => (() => (__webpack_require__(4600))), 1);
			register("@react-aria/toast", "3.1.0", () => (() => (__webpack_require__(9759))), 1);
			register("@react-aria/utils", "3.34.0", () => (() => (__webpack_require__(5590))), 1);
			register("@react-stately/overlays", "3.7.0", () => (() => (__webpack_require__(6334))), 1);
			register("@react-stately/toast", "3.2.0", () => (() => (__webpack_require__(8068))), 1);
			register("react-dom/client", "19.2.5", () => (() => (__webpack_require__(5500))), 1);
			register("react-dom/server", "19.2.5", () => (() => (__webpack_require__(366))), 1);
			register("react-dom", "19.2.5", () => (() => (__webpack_require__(8899))), 1);
			register("react/jsx-runtime", "19.2.5", () => (() => (__webpack_require__(4146))), 1);
			register("react", "19.2.5", () => (() => (__webpack_require__(1162))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};